import React from 'react';
import { Box, Inscription, PDFIcon, RawButton, RemoveIcon, useResponsive } from '@common-fe/common-fe';

import { FileImage, FileType } from '@/common/constants';
import truncateFileName from '@/utils/modifiers/truncateFileName';

interface Props {
  file: FileImage;
  onRemove: (file: FileImage) => void;
  onClick: () => void;
}

const IMAGE_TYPES: string[] = [FileType.JPEG, FileType.JPG, FileType.PNG, FileType.HEIC, FileType.HEIF];

const AppealFileItem: React.FC<Props> = ({ file, onRemove, onClick }) => {
  const isImage = IMAGE_TYPES.includes(file.type);
  const { isMobile } = useResponsive();

  return (
    <Box
      direction="row"
      align="center"
      justify="between"
      pad={{ horizontal: 'spacing24', vertical: 'spacing12' }}
      round="container1Round"
      border={{ size: 'small', color: 'border2' }}
      margin={{ top: 'spacing12' }}
      data-testid="appeal-file-item"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <Box direction="row" align="center" gap="spacing12">
        {isImage ? (
          <img
            src={file.preview || file.url}
            alt={file.name}
            width={48}
            height={48}
            style={{ borderRadius: 4, objectFit: 'cover', flexShrink: 0 }}
            data-testid="appeal-file-item-thumbnail"
          />
        ) : (
          <Box
            width="48px"
            height="48px"
            align="center"
            justify="center"
            flex={{ shrink: 0 }}
            data-testid="appeal-file-item-thumbnail"
          >
            <PDFIcon size="32px" />
          </Box>
        )}
        <Inscription color="textBody" data-testid="appeal-file-item-name">
          {isMobile ? truncateFileName(file.name) : file.name}
        </Inscription>
      </Box>

      <RawButton
        onClick={(e) => { e.stopPropagation(); onRemove(file); }}
        data-testid="appeal-file-item-remove"
      >
        <RemoveIcon color="danger" size="24px" />
      </RawButton>
    </Box>
  );
};

export default AppealFileItem;
